<template>
  <div
    class="grouping-container"
    :class="{ official: tabIndex === 2 }"
    :style="{ height: tabIndex === 2 ? officialHeight + 'px' : 'auto' }"
  >
    <template v-if="groupingShow">
      <header class="head">
        <h4>客户分群</h4>
        <div class="tab-line">
          <div
            class="tab-item"
            @click="handleSwitch(1)"
            :class="{ active: tabIndex == '1' }"
            :style="{
              color: tabIndex == '1' ? globalBG : '',
              'border-top': tabIndex == '1' ? '2px solid ' + globalBG : '',
            }"
          >
            人群列表
            <span></span>
          </div>
          <div
            class="tab-item"
            @click="handleSwitch(2)"
            :class="{ active: tabIndex == '2' }"
            :style="{
              color: tabIndex == '2' ? globalBG : '',
              'border-top': tabIndex == '2' ? '2px solid ' + globalBG : '',
            }"
          >
            官方推荐人群
            <span></span>
          </div>
        </div>

        <div class="head-cnt">
          <!-- 提示 -->
          <div class="tips">
            <img
              src="@/assets/images/new_icon_reminder.png"
              style="
                display: inline-block;
                float: left;
                position: relative;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 0px -18px 0 0px;
              "
            />
            <div class="area" style="margin-left: 24px" v-if="tabIndex === 1">
              <span>温馨提示</span>
              <p>
                1.此功能为京东官方功能，必须报备店铺签名后才可以筛选出数据，营销效果分析需要第二天才可以查看!
                <span
                  class="set"
                  style="color: #7f85e9"
                  v-zoom="{ from: pageName, name: '去设置' }"
                  @click="setDialogVisible = true"
                  >去设置</span
                >
              </p>
              <span style="margin-bottom: 4px"
                >2.
                官方规定：每个商家的人群策略最多创建200个（不包含系统人群），若您的策略已到达上限，请先删除一些无用分组，再进行人群创建。</span
              >
              <!-- <span style="line-height: 20px"
                >2.
                京东官方短信频控规则：同一商家2天内给同一手机号发送营销短信条数不超过1条；每个手机号每
                1 天只能收到 3 条京东商家短信，每 2 天只能收到 5
                条京东商家短信</span
              > -->
            </div>
            <div class="area" style="margin-left: 24px" v-if="tabIndex === 2">
              <span>使用说明</span>
              <p>
                1.依赖于官方智能算法，每天为商家提供大中小三个转化率高的人群标签策略包。若策略人数大于100，可一键转化为人群或直接营销，小于100无法营销；
              </p>
              <span style="margin-bottom: 4px">
                2.人群策略每天都会更新，为保证使用效果，建议当天使用。该功能目前只有部分类目开放，若无人群包则目前该类目尚不支持官方推荐的人群包；
              </span>
            </div>
          </div>
          <!-- 官方人群推荐 -->
          <ul class="tempList official" v-if="tabIndex === 2">
            <template v-for="(item, index) in officialList">
              <li class="item-box" :key="index">
                <div class="item">
                  <div class="headName">
                    <img
                      class="i"
                      src="../../assets/images/systemIcon.png"
                      alt=""
                    />
                    <el-tooltip
                        v-if="item.strategyName.length > 13"
                        effect="light"
                        :content="item.strategyName"
                        placement="bottom"
                      >
                        <span class="name">{{ item.strategyName}}</span></el-tooltip
                      >
                    <span class="name"  v-if="item.strategyName.length <= 13">{{item.strategyName}}</span>
                  </div>
                  <el-popover
                    v-if="item.searchQueryDesc.length > 15"
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    :content="item.searchQueryDesc"
                  >
                    <p class="desc" slot="reference">
                      {{ item.searchQueryDesc }}
                    </p></el-popover
                  >
                  <p class="desc" v-if="item.searchQueryDesc.length <= 15">
                    {{item.searchQueryDesc}}
                  </p>
                  <div class="footBtn">
                    <p>{{item.userNum}} <span>人</span></p>
                    <div class="btns">
                      <el-button class="yinxiao_button2" @click="handleOfficalMarket(item)">立即营销</el-button>
                    </div>
                  </div>
                </div>
              </li>
            </template>   
          </ul>
          <div class="no-goods" v-if="tabIndex === 2 && officialList.length === 0">
            <img src="@/assets/images/default/no_goods.png" alt="">
            <p>没有官方人群推荐哦~</p>
          </div>
          <template v-if="tabIndex === 1">
            <!-- 系统推荐人群 -->
            <div class="systemDesc">
              <p>
                <span class="system">系统推荐人群</span>
                <span class="update">数据更新时间：{{ this.currentdate }}</span>
              </p>
              <span class="open" v-if="!openSystem" @click="openSystem = true"
                >展开</span
              >
              <span class="open" v-else @click="openSystem = false">收起</span>
            </div>
            <!-- 推荐模块 -->
            <ul class="tempList" :class="openSystem ? 'check' : ''">
              <template v-for="item in systemData">
                <li
                  class="item-box"
                  v-if="!item.isHide"
                  :key="item.precisionCrowdStrategyId"
                >
                  <div class="item">
                    <div class="headName">
                      <img
                        class="i"
                        src="../../assets/images/systemIcon.png"
                        alt=""
                      />
                      <el-tooltip
                        v-if="item.name.length > 12"
                        effect="light"
                        :content="item.name"
                        placement="bottom"
                      >
                        <span class="name">{{ item.name }}</span></el-tooltip
                      >
                      <div class="wrap-name">
                        <span class="name" v-if="item.name.length <= 12">{{
                          item.name
                        }}</span>
                        <img
                          v-if="item.logoType === 1"
                          src="@/assets/images/tag_hot.png"
                          alt=""
                        />
                        <img
                          v-if="item.logoType === 2"
                          src="@/assets/images/tag_new.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <el-popover
                      v-if="item.description.length > 15"
                      placement="top-start"
                      width="200"
                      trigger="hover"
                      :content="item.description"
                    >
                      <p class="desc" slot="reference">
                        {{ item.description }}
                      </p></el-popover
                    >
                    <p class="desc" v-if="item.description.length <= 15">
                      {{ item.description }}
                    </p>
                    <!-- <p class="desc" v-if="item.description.length<=10">{{ item.description }}</p> -->
                    <div class="footBtn">
                      <p>{{ item.count }} <span>人</span></p>
                      <div class="btns">
                        <el-button
                          class="yinxiao_button4"
                          v-if="
                            (item.type == 0 || item.type == 1) &&
                            item.count != 0
                          "
                          @click="handleAnalysis(item)"
                          >人群分析</el-button
                        >
                        <el-button v-else class="yinxiao_button3"
                          >立即营销</el-button
                        >
                        <el-button
                          v-zoom="{ from: pageName, name: '立即营销' }"
                          v-show="item.count != 0"
                          class="yinxiao_button2"
                          @click="goToMarketing(item)"
                          >立即营销</el-button
                        >
                        <el-button
                          v-show="item.count == 0"
                          class="yinxiao_button3"
                          >立即营销</el-button
                        >
                      </div>
                    </div>
                  </div>
                </li>
              </template>
            </ul>
          </template>
        </div>
      </header>
      <!-- 底部表格 -->
      <footer v-if="tabIndex === 1" class="footTable">
        <div class="systemDesc">
          <p>
            <span class="system">我的人群库</span>
            <span class="update">数据更新时间：{{ this.currentdate }}</span>
          </p>
        </div>
        <!-- 查询条件 -->
        <div class="search">
          <ul class="right" style="margin-top: 10px">
            <li class="line" style="margin-right: 12px">
              <span>人群类型：</span>
              <el-select v-model="search.type">
                <el-option
                  v-for="(item, index) in peopleList"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                  >{{ item.label }}</el-option
                >
              </el-select>
            </li>
            <li class="line">
              <span>人群名称：</span>
              <el-input
                placeholder="请输入人群名称..."
                v-model="search.name"
                style="margin-right: 12px"
              ></el-input>
            </li>
            <li class="line">
              <span>人群描述：</span>
              <el-input
                placeholder="请输入人群描述..."
                v-model="search.description"
              ></el-input>
            </li>
            <li class="btn">
              <button
                @click="getList"
                ref="focus"
                v-zoom="{ from: pageName, name: '查询列表' }"
                style="width: 98px"
              >
                <i
                  class="el-icon-search"
                  style="
                    display: inline-block;
                    width: 14px;
                    height: 12px;
                    margin-top: -10px;
                  "
                ></i>
                查询
              </button>
              <button @click="reset" style="width: 98px">重置</button>
            </li>
          </ul>
        </div>
        <div class="search" style="margin: 20px 0">
          <div class="left">
            <button
              v-zoom="{ from: pageName, name: '创建人群' }"
              class="biaoqian_button"
              @click="labelCircle"
            >
              创建人群<span style="color: #fff">({{ count }}/200)</span>
            </button>
            <button
              class="biaoqian_button1"
              :disabled="synchLoading"
              v-loading="synchLoading"
              @click="handleSynch"
            >
              同步数坊人群
            </button>
            <el-button
              v-zoom="{ from: pageName, name: '上传人群' }"
              class="biaoqian_button2"
              style="margin-top: 10px"
              @click="dialogGenerate = true"
              >上传人群</el-button
            >
            <!-- <div>
              <span style="padding-top: 10px">{{ count }}/200</span>
            </div> -->
          </div>
        </div>
        <!-- 表格 -->
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          tooltip-effect="light"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="name" label="人群名称" width="180px">
            <template slot-scope="scope">
              <img
                v-if="scope.row.logoType === 1"
                src="@/assets/images/tag_hot.png"
                alt=""
              />
              <img
                v-if="scope.row.logoType === 2"
                src="@/assets/images/tag_new.png"
                alt=""
              />
              <span
                v-if="scope.row.logoType == 1 || scope.row.logoType == 2"
                style="padding-left: 8px"
                >{{ scope.row.name }}</span
              >
              <span v-if="scope.row.logoType != 1 && scope.row.logoType != 2">{{
                scope.row.name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="人群类型" width="120px">
            <template slot-scope="scope">
              {{
                scope.row.type == 1
                  ? "自定义人群"
                  : scope.row.type == 0
                  ? "系统分组"
                  : scope.row.type == 7
                  ? "数坊人群"
                  : scope.row.type == 8
                  ? "上传人群"
                  : scope.row.type == 9
                  ? "官方推荐人群"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="count" label="人群数量（人）" width="130px">
          </el-table-column>
          <el-table-column prop="description" label="人群描述" min-width="200px">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170px">
          </el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="170px">
            <template slot-scope="scope">
              <div class="operation-btn">
                {{currentdate}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="320px">
            <template slot-scope="scope">
              <div class="operation-btn">
                <el-button
                  type="text"
                  class="titleColorR"
                  style="
                    width: 70px;
                    margin-left: 0;
                    padding-left: 0 !important;
                  "
                  v-if="
                    (scope.row.type == 0 || scope.row.type == 1) &&
                    scope.row.count != 0
                  "
                  @click="handleAnalysis(scope.row)"
                  v-zoom="{ from: pageName, name: '人群分析' }"
                  >人群分析</el-button
                >
                <el-button
                  type="text"
                  style="
                    width: 70px;
                    margin-left: 0;
                    padding-left: 0 !important;
                  "
                  class="titleColorB"
                  v-else
                  >人群分析</el-button
                >
                <span class="titleColorB" v-if="scope.row.count <= 0"
                  >营销</span
                >
                <span
                  class="titleColorR"
                  v-zoom="{ from: pageName, name: '营销' }"
                  @click="goToMarketing(scope.row)"
                  v-else
                  >营销</span
                >
                <span
                  class="titleColorB"
                  v-if="scope.row.type == 0 || scope.row.type == 7 || scope.row.type == 9"
                  >编辑</span
                >
                <span
                  class="titleColorR"
                  v-else-if="scope.row.type != 0"
                  @click="handleEdit(scope.row)"
                  v-zoom="{ from: pageName, name: '编辑' }"
                  >编辑</span
                >
                <span
                  class="titleColorB"
                  v-if="scope.row.type == 0 || scope.row.type == 7"
                  >删除</span
                >
                <span
                  class="titleColorR"
                  v-else-if="scope.row.type != 0"
                  @click="handleDelete1(scope.row)"
                  v-zoom="{ from: pageName, name: '删除' }"
                  >删除</span
                >
                <el-tooltip
                  class="item"
                  effect="light"
                  v-if="scope.row.lastSynDmpStatus === false"
                  content="DMP同步中"
                  placement="top"
                >
                  <span class="titleColorB">同步DMP</span>
                </el-tooltip>
                <span v-else-if="scope.row.count === 0" class="titleColorB"
                  >同步DMP</span
                >
                <template v-else>
                  <el-tooltip
                    class="item"
                    v-if="scope.row.lastSynDmpTime"
                    effect="light"
                    :key="scope.$index"
                    :content="'上次同步时间' + scope.row.lastSynDmpTime"
                    placement="top"
                  >
                    <span
                      class="titleColorR"
                      v-zoom="{ from: pageName, name: '同步DMP' }"
                      @click="handleSynDMP(scope.row)"
                      >同步DMP</span
                    >
                  </el-tooltip>
                  <span
                    v-else
                    class="titleColorR"
                    v-zoom="{ from: pageName, name: '同步DMP' }"
                    @click="handleSynDMP(scope.row)"
                    >同步DMP</span
                  >
                </template>

                <span
                  class="titleColorR"
                  v-if="scope.row.type == 1"
                  v-zoom="{ from: pageName, name: '复制' }"
                  @click="handleCopy(scope.row)"
                  >复制</span
                >
                <span class="titleColorB" v-else>复制</span>

                <!-- <el-button
                  type="text"
                  v-if="scope.row.count <= 0"
                  style="color: #ddd"
                  >营销</el-button
                >
                <el-button type="text" @click="goToMarketing(scope.row)" v-else
                  >营销</el-button
                >
                <el-button
                  v-if="scope.row.type == 0 || scope.row.type == 7"
                  type="text"
                  style="color: #ddd"
                  >编辑</el-button
                >
                <el-button
                  v-else-if="scope.row.type != 0"
                  type="text"
                  @click="handleEdit(scope.row)"
                  >编辑</el-button
                > -->
                <!-- <el-button
                  v-if="scope.row.type == 0 || scope.row.type == 7"
                  type="text"
                  style="color: #ddd"
                  >删除</el-button
                >
                <el-button
                  v-else-if="scope.row.type != 0"
                  type="text"
                  @click="handleDelete1(scope.row)"
                  >删除</el-button
                > -->
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="search.size"
          :current-page="search.current"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </footer>
    </template>

    <!-- 人群分析 -->
    <analysis
      v-if="analysisIsShow"
      @back="analysisBack"
      :sellerList="sellerList"
      :show="analysisIsShow"
      :crowdArray="crowdArray"
    ></analysis>
    <!-- 人群筛选 -->
    <people-filter
      @on-cancel="onCancel"
      :editData="editData"
      :visible="peopleFilter"
    ></people-filter>
    <!-- 去设置弹层 -->
    <SetDialog
      :visible="setDialogVisible"
      @close="setDialogVisible = false"
    ></SetDialog>
    <!-- 删除弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible"
      width="400px"
      :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >确定要删除吗?</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="上传人群"
      :before-close="closehandleSc"
      :visible.sync="dialogGenerate"
      width="640px"
    >
      <el-form
        :model="generateForm"
        label-width="100px"
        style="padding: 0 40px 0 0"
      >
        <el-form-item label="人群名称:" required>
          <el-input v-model="generateForm.name"></el-input>
        </el-form-item>
        <el-form-item label="人群描述:" required>
          <el-input v-model="generateForm.description"></el-input>
        </el-form-item>
        <el-form-item label="上传方式:" required>
          <el-radio-group v-model="generateForm.uploadType">
            <el-radio :label="0">输入用户pin</el-radio>
            <el-radio :label="1">上传用户pin</el-radio>
          </el-radio-group>
          <div v-if="generateForm.uploadType == 0" style="margin-top: 20px">
            <el-input
              type="textarea"
              v-model="generateForm.pins"
              :autosize="{ minRows: 4, maxRows: 6 }"
            >
            </el-input>
            <div class="tips">
              <img
                src="@/assets/images/new_icon_reminder.png"
                style="
                  display: inline-block;
                  float: left;
                  position: absolute;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 8px 4px 0 0;
                "
              />
              <div class="area" style="margin-left: 22px">
                <p>1.每行一个用户pin;</p>
                <p>2.手动输入，一次输入最多支持2000行;</p>
                <p>
                  3.上传人群中系统只会识别已购会员、品牌会员、0元开卡会员，其他维度的用户PIN会被去除。
                </p>
              </div>
            </div>
          </div>
          <div v-else style="margin-top: 20px">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :on-change="handleChange"
              :file-list="fileList"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :on-progress="handleProgress"
              :data="{
                name: generateForm.name,
                description: generateForm.description,
                uploadType: 1,
              }"
              accept=".txt"
            >
              <el-button size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传txt文件，且不超过20M
              </div>
            </el-upload>
            <el-progress
              :percentage="percentage"
              :format="format"
              :color="customColors"
              v-if="isShow"
            ></el-progress>
            <div class="tips">
              <img
                src="@/assets/images/new_icon_reminder.png"
                style="
                  display: inline-block;
                  float: left;
                  position: absolute;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 8px 4px 0 0;
                "
              />
              <div class="area" style="margin-left: 22px">
                <p>
                  1.目前只支持上传TXT格式文件，单次上传最大20M;
                  <el-button
                    type="text"
                    style="margin-left: 20px; width: 60px"
                    @click="downloadTemplate"
                    >下载模板</el-button
                  >
                </p>
                <p>2.每行一个用户pin;</p>
                <p>
                  3.上传人群中系统只会识别已购会员、品牌会员、0元开卡会员，其他维度的用户PIN会被去除。
                </p>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -20px">
        <el-button
          @click="dialogGenerate = false"
          style="border: 1px solid #ddd"
          >取 消</el-button
        >
        <el-button type="primary" @click="generateCrowd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSellerInfo } from "@/api/sellerController";
import { getSellercats } from "@/api/analysis/ware-controller";
import peopleFilter from "@/components/people-filter";
import analysis from "./components/analysis";
import SetDialog from "@/components/SetDialog";
import { getArea } from "@/api/memberLabel";

import {
  getOfficialRecommend,
  officialMarket,
  queryMemberCrowd,
  addMemberCrowd,
  createdCount,
  crowdInstance,
  packStatus,
  delMemberCrowd,
  isvUsrPack,
  crowdAnalysis,
  uploadManual,
  uploadImport,
  synDmp,
} from "@/api/manage/memberCrowdController";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    peopleFilter,
    analysis,
    SetDialog,
  },
  data() {
    return {
      tabIndex: 1,
      officialHeight: document.body.clientHeight - 60 - 40 - 10,
      pageName: "客户营销-客户分群",
      customColors: "#67c23a",
      show: false,
      crowdArray: {},
      isShow: false,
      fileList: [],
      uploadUrl: "",
      generateForm: {
        name: "",
        description: "",
        uploadType: 0,
        pins: "",
      },
      dialogGenerate: false,
      synchLoading: false,
      // 首屏显示隐藏控制
      groupingShow: true,
      // 查询条件
      search: {
        name: "",
        description: "",
        type: "",
        size: 10,
        current: 1,
      },
      nowopen1: "",
      outerVisible: false,
      // 系统人群数据
      systemData: [],
      openSystem: false,
      // 表格数据
      tableData: [],
      total: 0,
      // 表格加载状态控制
      tableLoading: false,
      // 人群分析状态控制
      analysisIsShow: false,
      // 人群筛选状态控制
      peopleFilter: false,
      // 人群编辑存储数据
      editData: null,
      setDialogVisible: false,
      count: "",
      currentdate: "",
      percentage: 0,
      sellerList: [],
      shopMemberType: "",
      initialize: false, // 是否已经初始化
      peopleList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "系统人群",
          value: 0,
        },
        {
          label: "自定义人群",
          value: 1,
        },
        {
          label: "数坊人群",
          value: 7,
        },
        {
          label: "上传人群",
          value: 8,
        },
        {
          label: "官方推荐人群",
          value: 9,
        },
      ],
      officialList: [],
      isClick: false, // 防止接口请求前多次点击
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
    venderId(nVal, oVal) {
      return this.$store.getters.venderId;
    },
    shopInfo() {
      return this.$store.getters.shopInfo;
    },
  },
  watch: {
    initialize(newVal){
      if (this.$route.query.create && newVal) {
        this.labelCircle()
      }
    },
    dialogGenerate(newVal) {
      if (newVal == false) {
        this.generateForm.name = "";
        this.generateForm.description = "";
        this.generateForm.pins = "";
        this.percentage = 0;
      }
    },
    // from精准营销，自动打开创建人群
    initialize(newVal){
      if (newVal&&this.$route.query.create) {
         this.labelCircle()
      }
    },
    shopInfo(newVal) {
      if (newVal) {
        this.shopMemberType = this.shopInfo.shopMemberType;
        this.getList();
        this.getSystemList();
      }
    },
  },
  created() {
    this.shopMemberType = this.shopInfo.shopMemberType;
    this.init();
    this.getList();
    this.getSystemList();
    this.getOfficialList();
    getSellerInfo().then((resp) => {
      this.editUserInfo(resp && resp.data);
    });
    getSellercats().then((res) => {
      this.sellerList = res.data;
    });
  },
  mounted() {
    this.dateFormat();
    
  },
  methods: {
    // 获取官方推荐人群
    getOfficialList() {
      getOfficialRecommend().then(res => {
        this.officialList = res.data;
      })
    },
    handleSwitch(index) {
      this.tabIndex = index;
    },
    init() {
      getArea().then((res) => {
        if (res.code === 1) {
          let cityArr = [];
          // return
          // 格式化数据
          res.data.forEach((item) => {
            // 省份
            item.children.forEach((province) => {
              // 城市
              province.children.forEach((city) => {
                cityArr.push(city);
              });
              province.children = province.children;
            });
            item.children = item.children;
          });
          // console.log(cityArr);
          if (!sessionStorage.getItem("cityArr")) {
            sessionStorage.setItem("cityArr", JSON.stringify(cityArr));
          }
        }
      });
    },
    format(percentage) {
      return percentage === 100 ? "满" : `${percentage}%`;
    },
    downloadTemplate() {
      let url = "",
        fileName = "";
      url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/upload_crowd_pin.txt";
      fileName = "upload_crowd_pin.txt";
      let content = "用户pin1\n用户pin2\n用户pin3\n用户pin4\n用户pin5";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(content)
      );
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    closehandleSc() {
      if (this.percentage < 100 && this.percentage > 0) {
        this.$confirm("文件上传中, 是否关闭弹窗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            this.dialogGenerate = false;
          })
          .catch(() => {});
      } else {
        this.dialogGenerate = false;
      }
    },
    //上传人群
    generateCrowd() {
      if (!this.generateForm.name) {
        this.$message.warning("人群名称不能为空");
        return;
      }
      if (!this.generateForm.description) {
        this.$message.warning("人群描述不能为空");
        return;
      }
      if (!this.files && this.generateForm.uploadType == 1) {
        this.$message.warning("未导入文件");
        return;
      }
      if (this.generateForm.uploadType == 0) {
        uploadManual(this.generateForm)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success(res.message);
              // this.isShow = false;
              this.files = null;
              this.fileList = [];
              this.dialogGenerate = false;
              this.getList();
            } else {
              this.$message.warning(res.message);
            }
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      } else {
        this.isShow = true;
        let formData = new FormData();
        formData.append("file", this.files);
        formData.append("name", this.generateForm.name);
        formData.append("description", this.generateForm.description);
        formData.append("uploadType", 1);
        let setInt = setInterval(() => {
          if (this.percentage < 99) {
            this.percentage += 1;
          } else {
            this.percentage = 99;
          }
        }, 100);
        uploadImport(formData)
          .then((res) => {
            if (res && res.code == 1) {
              clearInterval(setInt);
              this.percentage = 100;
              this.$message.success(res.message);
              setTimeout(() => {
                this.dialogGenerate = false;
                this.isShow = false;
                this.files = null;
                this.fileList = [];
                this.getList();
              }, 800);
            } else {
              clearInterval(setInt);
              this.percentage = 0;
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      }
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        // this.process = 100;
        // this.success = false;
        this.$message.warning("上传模板大小不能超过 20MB!");
        return;
      }
      this.files = file;
      // this.isShow = true;
      let titleNew = [{ name: file.name, url: "" }];
      this.fileList = titleNew;
    },
    handleProgress(file) {
      // if(this.dialogGenerate == false){
      //   this.$message.warning("上传中")
      // }
    },
    handleRemove(file, fileList) {
      this.files = null;
      // this.isShow = false;
    },
    //导入上传人群
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
      // let titleNew = [{ name: file.name, url: "" }];
      // this.fileList = titleNew;
      // console.log(this.fileList[0].name,222);
    },
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO",
    }),
    getCreatedCount() {
      createdCount({ venderId: this.venderId }).then((res) => {
        this.count = res.data && res.data.count;
      });
    },
    //获得当前时间
    dateFormat() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = " ";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      this.currentdate = currentdate;

      // this.$refs.searchForm.submitForm("formSearch");
    },
    // 获取人群列表
    getList(type) {
      if (type) {
        this.search.current = 1;
      }
      this.tableLoading = true;
      this.getCreatedCount();
      queryMemberCrowd(this.search).then((res) => {
        this.initialize = true;
        var tableData = res && res.data.records;
        this.total = res && +res.data.total;
        this.tableLoading = false;
        var shopMemberType = this.shopMemberType;
  
        tableData = tableData.filter((item) => {
          var flag = true;
          if (shopMemberType == "2" || shopMemberType == "4") {
            // 显示店铺会员，隐藏品牌
            if (
              item.name == "开卡未购会员转化（品牌会员）" ||
              item.name == "未开卡人群入会引导（品牌会员卡）"
            ) {
              flag = false;
            }
          } else if (shopMemberType == "3" || shopMemberType == "5") {
            // 隐藏店铺
            if (
              item.name == "开卡未购会员转化（店铺会员）" ||
              item.name == "未开卡人群入会引导（店铺会员卡）"
            ) {
              flag = false;
            }
          }
          if (flag) {
            return item;
          }
        });

        if (tableData && tableData.length > 0) {
          var sum = 0;
          tableData.forEach((item) => {
            sum += item.count;
          });
          if (sum == "0") {
            this.$message.warning("人群数据正在推送，请耐心等待哦~");
          }
        }
        this.tableData = tableData;
      });
    },
    // 获取系统人群
    getSystemList() {
      const params = {
        size: 50,
        type: 0,
      };
      queryMemberCrowd(params).then((res) => {
        this.systemData = res && res.data.records;
        var shopMemberType = this.shopMemberType;
      
        if (this.systemData && this.systemData.length > 0) {
          this.systemData.forEach((item) => {
            if (shopMemberType == "2" || shopMemberType == "4") {
              // 显示店铺会员，隐藏品牌
              if (
                item.name == "开卡未购会员转化（品牌会员）" ||
                item.name == "未开卡人群入会引导（品牌会员卡）"
              ) {
                item.isHide = true;
              }
            } else if (shopMemberType == "3" || shopMemberType == "5") {
              // 隐藏店铺
              if (
                item.name == "开卡未购会员转化（店铺会员）" ||
                item.name == "未开卡人群入会引导（店铺会员卡）"
              ) {
                item.isHide = true;
              }
            }
          });
        }
      });
    },
    // 点击人群分析
    handleAnalysis(value) {
      this.groupingShow = false;
      this.analysisIsShow = true;
      this.show = true;
      this.crowdArray = value;
    },
    // 同步数坊人群
    handleSynch() {
      this.synchLoading = true;
      isvUsrPack().then((res) => {
        if (res.code == "1") {
          this.synchLoading = false;
        }
      });
    },
    // 标签圈人
    labelCircle() {
      if (!this.initialize) {
        this.$message.warning("请先完成初始化！");
        return;
      }
      if (this.total >= 200) {
        this.$message.warning(
          "自定义人群数量已达到上限，请删除人群后再创建哦~"
        );
        return;
      }

      this.groupingShow = false;
      this.peopleFilter = true;
    },
    // 点击编辑
    handleEdit(data) {
      if (data.type != 1) {
        this.$message.warning("非自定义人群不可编辑");
        return;
      }
      this.editData = data;
      this.groupingShow = false;
      this.peopleFilter = true;
    },
    // 复制
    handleCopy(data) {
      if (data.type != 1) {
        this.$message.warning("非自定义人群不可编辑");
        return;
      }
      data.precisionCrowdStrategyId = "";
      data.strategyId = "";
      data.name = data.name + "副本";
      if (data.name.length > 20) {
        data.name = data.name.substr(0, 20);
      }
      this.editData = data;
      this.groupingShow = false;
      this.peopleFilter = true;
    },
    // 同步DMP
    handleSynDMP(row) {
      this.$refs.focus.focus(); // 防止滑动的样式再次显示

      this.$confirm("是否确定同步？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        var param = {
          precisionCrowdStrategyId: row.precisionCrowdStrategyId,
        };
        if (row.strategyId) {
          param.strategyId = row.strategyId;
        } else {
          param.searchId = row.searchId;
        }

        synDmp(param).then((res) => {
          if (res.code == "1") {
            if (res.data.code == "1") {
              this.$message.success("申请DMP任务已提交成功");
            } else {
              this.$message.error(res.message);
            }
            this.getList();
          }
        });
      });
    },

    handleDelete1(nowopen) {
      this.nowopen1 = nowopen;
      this.outerVisible = true;
    },
    //关闭删除弹框
    closehandleDelete() {
      this.outerVisible = false;
      this.$message.warning("已关闭删除");
    },
    handleDeleteTable() {
      this.handleDelete(this.nowopen1);
    },
    // 点击删除
    handleDelete({ type, strategyId, precisionCrowdStrategyId }) {
      if (type == 0 || type == 7) {
        this.$message.warning("非自定义人群不可删除");
        return;
      }
      // this.$confirm("确定要删除吗?", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      // })
      // .then(() => {
      delMemberCrowd(precisionCrowdStrategyId, strategyId)
        .then((res) => {
          if (res && res.code == 1) {
            this.outerVisible = false;
            this.$message.success("删除成功!");
            this.getList();
            this.getSystemList();
          }
          // })
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 人群筛选隐藏
    onCancel(state) {
      if (this.editData) this.editData = null;
      this.peopleFilter = false;
      this.groupingShow = true;
      if (state) {
        this.getList();
        this.getSystemList();
      }
    },
    // 人群分析隐藏
    analysisBack() {
      this.analysisIsShow = false;
      this.groupingShow = true;
    },
    // 分页信息变化
    handleSizeChange(val) {
      this.search.current = 1;
      this.search.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.current = val;
      this.getList();
    },
    // 点击营销跳转营销页面
    goToMarketing(item) {
      window.localStorage.setItem("strategy", JSON.stringify(item));

      // return
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/accurate_market",
        query: { to: "grouping" },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 官方推荐人群-立即营销
    handleOfficalMarket(item) {
      if (this.isClick) {
        return
      }
      var level = item.strategyRecLevel;
      var param = {
        level
      }
      this.isClick = true;
      officialMarket(param).then(res => {
        this.isClick = false;
        if (res.code == '1') {
          this.goToMarketing(res.data)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    reset() {
      this.search.name = "";
      this.search.description = "";
      this.search.type = "";
      this.search.size = 10;
      this.search.current = 1;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-line {
  font-size: 14px;
  color: #666666;
  border-bottom: 1px solid #dddddd;
  margin: 24px 28px 0 28px;

  .tab-item {
    // padding: 15px 0;
    text-align: center;
    width: 106px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    margin-right: 2px;
    border: 1px solid #dddddd;
    border-bottom: none;

    span {
      position: absolute;
      width: 100%;
      left: 50%;
      height: 2px;
      transform: translateX(-50%);
      bottom: -2px;
      display: none;
    }
    &.active {
      border-top: 2px;
      span {
        display: block;
        background: #fff;
      }
    }
  }
}
.grouping-container {
  min-width: 1080px;
  box-sizing: border-box;
  padding: 10px 20px 60px;
  &.official {
    padding-bottom: 12px;
    min-height: 500px;
    .head {
      height: 100%;
    }
  }
  .no-goods{
    text-align: center;
    color: #333;
    font-size: 14px;
    padding-top: 105px;
  }
  button {
    outline: none;
    border-radius: 3px;
    transition: all 0.2s;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    border: none;
    cursor: pointer;
  }
  .buttonBox {
    .b1 {
      width: 98px;
      height: 32px;
      color: #666666;
      // position: absolute;
      border-radius: 3px;
      margin-top: 20px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .b2 {
      width: 98px;
      // position: absolute;
      // margin-right: 80px;
      height: 32px;
      margin: 20px 80px 10px 10px;
      border: 1px solid #fe4d45;
      color: #ffffff;
      border-radius: 3px;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
  .systemDesc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    margin-top: 20px;
    padding: 7px 12px;
    // background: rgba(250, 250, 250, 1);
    font-size: 14px;
    font-weight: 400;
    color: #333;
    background-color: #fafafa;
    p {
      display: flex;
      align-items: center;
      margin: 0;
      .system {
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        &::before {
          content: "";
          border-left: 4px solid #fe4d45;
          margin-right: 4px;
          border-radius: 3px;
        }
      }
      .update {
        margin-left: 8px;
      }
    }
    .open {
      color: #fe4d45;
      cursor: pointer;
    }
  }
  .head {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    h4 {
      box-sizing: border-box;
      margin: 0;
      padding-left: 28px;
      height: 54px;
      line-height: 53px;
      border-bottom: 1px solid #f0f0f0;
      color: #2e3458;
      font-size: 16px;
      font-weight: bold;
    }
    .head-cnt {
      box-sizing: border-box;
      padding: 20px 28px 10px;
      .tips {
        display: flex;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 12px 12px 8px;
        background: rgba(250, 250, 250, 1);
        border-radius: 3px;
        font-size: 14px;
        font-weight: 400;
        color: #333;
        i {
          color: #fe8f8a;
        }
        .area {
          display: flex;
          flex-direction: column;
          margin-left: 10px;
          p {
            margin: 8px 0;
          }
          .set {
            margin-left: 20px;

            color: #7f85e9;
            cursor: pointer;
            &:hover {
              color: #fe4d45;
            }
          }
        }
      }
      .tempList {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 20px;
        max-height: 200px;
        overflow: hidden;
        transition: all 0.4s linear;
        .item-box {
          width: 25%;
          padding: 0 8px;
          @media screen and (max-width: 1540px) {
            padding: 0 6px;
          }
          margin-bottom: 20px;
          .item {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 16px 32px;
            @media screen and (max-width: 1760px) {
              padding: 16px 14px 10px 14px;
            }
            @media screen and (max-width: 1540px) {
              padding: 16px 10px 16px 10px;
            }
            min-height: 180px;
            border: 1px solid rgba(238, 238, 238, 1);
            border-radius: 4px;
            .headName {
              display: flex;
              align-items: center;
              .wrap-name {
                img {
                  position: relative;
                  top: -5px;
                  left: 2px;
                }
              }
              .i {
                width: 46px;
                height: 46px;
                margin-right: 16px;
                // background: linear-gradient(
                //   321deg,
                //   rgba(254, 203, 144, 1) 0%,
                //   rgba(255, 232, 206, 1) 100%
                // );
                border-radius: 50%;
                opacity: 1;
              }
              .name {
                color: #333;
                font-size: 16px;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .desc {
              color: #666;
              font-size: 14px;
              font-weight: 400;
              line-height: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              @media screen and (max-width: 1760px) {
                margin-top: 16px;
              }
            }
            .footBtn {
              display: flex;
              align-items: flex-end;
              justify-content: space-between;
              @media screen and (max-width: 1760px) {
                padding-top: 10px;
              }
              @media screen and (max-width: 1540px) {
                padding-top: 10px;
              }
              p {
                color: #fe4d45;
                font-size: 24px;
                @media screen and (max-width: 1760px) {
                  font-size: 22px;
                }
                @media screen and (max-width: 1540px) {
                  font-size: 20px;
                }
                font-weight: 500;
                span {
                  color: #999;
                  font-size: 14px;
                  font-weight: 400;
                }
              }
              .btns {
                text-align: center;
                @media screen and (max-width: 1740px) {
                  width: 90px;
                  // height: 28px;
                }
                .renqun_button1 {
                  width: 98px;
                  height: 32px;
                  color: #666666;
                  border: 1px solid #dddddd;
                  background-color: #fff;
                }
                .renqun_button1:hover {
                  color: #fe4d45;
                  border: 1px solid #fe4d45;
                  background-color: #fff4f4;
                }
                .yinxiao_button2 {
                  width: 92px;
                  height: 30px;
                  margin-top: 10px;
                  @media screen and (max-width: 1760px) {
                    width: 90px;
                    height: 30px;
                    margin: 6px 0 0 0 !important;
                  }
                  @media screen and (max-width: 1540px) {
                    width: 84px;
                    height: 28px;
                    margin: 6px 0 0 0 !important;
                  }
                  color: #fe4d45;
                  border: 1px solid #fe4d45;
                  background-color: #fff;
                }
                .yinxiao_button3 {
                  width: 98px;
                  height: 32px;
                  @media screen and (max-width: 1760px) {
                    width: 90px;
                    height: 30px;
                    margin: 6px 0 0 0 !important;
                  }
                  @media screen and (max-width: 1540px) {
                    width: 84px;
                    height: 28px;
                    margin: 6px 0 0 0 !important;
                  }
                  margin-top: 10px;
                  color: rgb(221, 221, 221);
                  border: 1px solid rgb(221, 221, 221);
                  background-color: #fff;
                }
                .yinxiao_button4 {
                  width: 98px;
                  height: 32px;
                  @media screen and (max-width: 1760px) {
                    width: 90px;
                    height: 30px;
                    margin: 6px 0 0 0 !important;
                  }
                  @media screen and (max-width: 1540px) {
                    width: 84px;
                    height: 28px;
                    margin: 6px 0 0 0 !important;
                  }
                  margin-top: 10px;
                  color: #999;
                  border: 1px solid #ccc;
                  background-color: #fff;
                }
                .yinxiao_button4:hover {
                  border-color: #FE4D45;
                  color: #FE4D45;
                  background-color: #FFF6F6;
                }
                .yinxiao_button2:hover {
                  color: #ffffff;
                  background-color: #fe4d45;
                }
                .yinxiao_button3:hover {
                   border: 1px solid rgb(221, 221, 221);
                }
              }
            }
          }
          &:nth-child(4n + 1) {
            padding: 0 8px 0 0;
            @media screen and (max-width: 1540px) {
              padding: 0 6px 0 0;
            }
          }
          &:nth-child(4n) {
            padding: 0 0 0 8px;
            @media screen and (max-width: 1540px) {
              padding: 0 0 0 6px;
            }
          }
          p {
            margin: 0;
          }
        }
        &.check {
          max-height: 100%;
        }
      }
    }
  }
  .footTable {
    box-sizing: border-box;
    padding: 20px 28px 30px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .search {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 20px 0;
      button {
        margin-top: 10px;
        // width: 98px;
        height: 32px;
        padding: 0 12px;
        line-height: 28px;
        margin-right: 8px;
        background-color: #fe4d45;
        vertical-align: middle;
        color: #fff;
      }
      .biaoqian_button:hover {
        opacity: 0.9;
        background-color: #fe4d45;
      }
      .biaoqian_button1 {
        // width: 98px;
        height: 32px;
        color: #fe4d45;
        border-radius: 3px;
        border: 1px solid #fe4d45;
        background-color: #fff;
        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
        &:active {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }
      .biaoqian_button2 {
        width: 98px;
        height: 32px;
        color: #666666;
        border-radius: 3px;
        border: 1px solid #dddddd;
        background-color: #fff;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }

      span {
        color: #7f85e9;
        font-size: 14px;
        font-weight: 400;
      }
      .right {
        display: flex;
        align-items: center;
        .line {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          span {
            margin-right: 4px;
            color: #333;
            white-space: nowrap;
          }
        }
        .btn {
          display: flex;
          margin-top: -10px;
          align-items: center;
          button {
            transition: all 0.3s;
            &:first-child {
              margin-left: 20px;
              color: #fe4d45;
              border: 1px solid #fe4d45;
              background-color: #fff;
              &:hover {
                background-color: #fe4d45;
                color: #fff;
              }
            }
            &:last-child {
              color: #666;
              border: 1px solid #ddd;
              background-color: #fff;
              &:hover {
                color: #fe4d45;
                background-color: #fff4f4;
                border: 1px solid #fe4d45;
              }
            }
          }
        }
      }
    }
    .operation-btn {
      .titleColorB {
        margin-left: 10px;
        color: #ddd;
        cursor: not-allowed;
      }
      .titleColorR {
        cursor: pointer;
        color: #7f85e9;
        margin-left: 10px;
        &:hover {
          color: #fe4d45;
        }
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
  .tips {
    display: flex;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 12px 12px 8px;
    background: #fff9f9;
    border-radius: 3px;
    font-size: 14px;
    // font-weight: 400;
    color: #333;
    margin-top: 10px;
    i {
      color: #fe8f8a;
    }
    .area {
      display: flex;
      flex-direction: column;
      margin-left: 10px;
      .set {
        margin-left: 20px;

        color: #7f85e9;
        cursor: pointer;
        &:hover {
          color: #fe4d45;
        }
      }
    }
  }
}
</style>